import React from 'react';

import { KB_LIVE_COPY } from '../../constants/training';
import type { SessionCompletedData } from '../../services/kbLiveFrames';
import { kbCompletionPercent } from '../../utils/kbItemProgress';
import { Button } from '../ui/button';

interface KbCompletionModalProps {
  summary: SessionCompletedData;
  onViewResults: () => void;
}

/** End of session. Scoring happens afterwards, so this only reports coverage. */
export const KbCompletionModal: React.FC<KbCompletionModalProps> = ({ summary, onViewResults }) => {
  const answered = summary?.itemsCompleted ?? 0;
  const total = summary?.totalItems ?? 0;

  return (
    <div className="modal-backdrop">
      <div role="dialog" aria-modal="true" aria-labelledby="kb-complete-title" className="modal-panel p-8 max-w-md w-full mx-4 text-center">
        <h3 id="kb-complete-title" className="heading-2 mb-2">
          {KB_LIVE_COPY.completedTitle}
        </h3>
        <div className="text-5xl font-bold text-ink mb-2">{kbCompletionPercent(answered, total)}%</div>
        <p className="text-ink-secondary mb-4">{KB_LIVE_COPY.completedAnswered(answered, total)}</p>
        <p className="text-sm text-ink-muted mb-6">{KB_LIVE_COPY.completedScoring}</p>
        <Button type="button" variant="primary" onClick={onViewResults} className="w-full">
          {KB_LIVE_COPY.viewResults}
        </Button>
      </div>
    </div>
  );
};

export default KbCompletionModal;
